import { formatMessage } from 'src/utils';
import { GridSizeType, GameTileProps } from './types';
import {
  MEDIUM_BREAKPOINT,
  LARGE_BREAKPOINT,
  SMALL_OUTFIT,
  MEDIUM_OUTFIT,
  BIG_OUTFIT,
} from './constants';
import { ImageType } from 'src/types/gameTypes';

export const selectProperStyles = (
  style: {
    small: string | string[];
    medium: string | string[];
    default: string | string[];
  },
  size?: GridSizeType
) => {
  switch (size) {
    case 'small':
      return style.small;
    case 'medium':
      return style.medium;
    default:
      return style.default;
  }
};

export const sliceGameList = (
  expectedAmount: number,
  gameList: GameTileProps[] = []
): GameTileProps[] =>
  [...gameList, ...new Array(expectedAmount)].slice(0, expectedAmount);

export const prepareGameInfoTooltip = (
  gameInfoTooltip: string | undefined,
  gameTitle: string
) =>
  formatMessage(gameInfoTooltip, {
    gameTitle,
  });

export const getOutfitSize = (windowWidth: number) => {
  if (
    windowWidth >= MEDIUM_BREAKPOINT.min &&
    windowWidth <= MEDIUM_BREAKPOINT.max
  ) {
    return MEDIUM_OUTFIT;
  } else if (windowWidth >= LARGE_BREAKPOINT.min) {
    return BIG_OUTFIT;
  }
  return SMALL_OUTFIT;
};

export const verifyImage = (asset?: ImageType) => {
  return !!(
    asset &&
    asset.alt.trim() !== '' &&
    asset.source?.base?.trim() !== '' &&
    asset.source.normal.includes('assets')
  );
};
